var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "facebook_svg__bg",
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F0F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "facebook_svg__fill",
    d: "M20.0075 16.9995L20.452 14.104H17.6735V12.225C17.6735 11.433 18.0615 10.6605 19.306 10.6605H20.569V8.1955C20.569 8.1955 19.423 8 18.327 8C16.039 8 14.5435 9.387 14.5435 11.8975V14.1045H12V17H14.5435V24H17.6735V17L20.0075 16.9995Z",
    fill: "currentColor"
  })));
};
export default SvgFacebook;